export const HeaderLogo = ({ className = "h-11 md:h-12" }) => (
  <img
    src="/images/logo-header-light.png"
    alt="T.A.L.K. — The Analog Life Kintsugi"
    data-testid="header-logo"
    className={`w-auto ${className}`}
  />
);

export default HeaderLogo;
